<template>
<div v-on:click="scrollUp" class="text-fuchsia-500 rounded-xl shadow bg-white text-center float-right cursor-pointer p-2 fixed right-5 bottom-5">
<svg class="w-8 h-8 stroke-current inline-block" xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#000000" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="bevel"><path d="M12 19V6M5 12l7-7 7 7"/></svg>
  </div>
</template>

<script>
export default {
    name: 'ScrollUpButton',
    data() {
        return {}
    },
    methods:{
        scrollUp: function(){
            window.scroll({ top:0, left:0, behavior: 'smooth'});
        }
    },
    components:{
    },
    props: {
        entry: {}
    }
}
</script>

<style scoped>
pre{
}
</style>
